import { render, staticRenderFns } from "./CollapsibleSection.vue?vue&type=template&id=94e24770&scoped=true"
import script from "./CollapsibleSection.vue?vue&type=script&lang=js"
export * from "./CollapsibleSection.vue?vue&type=script&lang=js"
import style0 from "./CollapsibleSection.vue?vue&type=style&index=0&id=94e24770&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e24770",
  null
  
)

export default component.exports